import { useState, useEffect } from "react";
import "./App.css";
import Light from "./Light/light";
import Chip from "./chip/chip";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import ToggleFullScreenLayout from "./toggleFullScreenLayout/toggleFullScreenLayout";
import FullpagePinLayout from "./components/fullpagePinLayout";
import Battery from "./battery/battery";
import Header from "./header/header";
import Algorithm from "./algorithm/algorithm";
import Custom from "./custom/custom";
import Cooperation from "./cooperation/cooperation";
import DOMPurify from "dompurify";
import MediaQuery, { useMediaQuery } from "react-responsive";
let language = document.querySelector('meta[name="language"]').content;
document.getElementById("root").setAttribute("lang", language);
document.getElementById("root").classList.add("no-cn");

let json = {
  text1: "轻稳全能",
  text2:
    '<div class="mainText">体感轻40%，可一手掌控，无需配件集成高性能灯麦设计。</div>我们探索轻稳之路，传承便携机身，颠覆性省力结构；力求全能之选，集成光与音的完美瞬间，让科技融合启发影像记录的无限想象。',
  text3: "观看视频",
  text4: "精密结构工艺。",
  text5:
    '<div class="mainText">WEEBILL 3 立体流畅机身以精密设计，精湛工艺和机械工程技术将390余个零部件集成一体</div>，机臂和内部结构加强处理，给足创作安全感，轻松驾驭复杂拍摄环境。',
  text6: "A4级轻量机身。",
  text7:
    '<div class="mainText">整机较同类轻约30%，增加10%的轴臂空间和50%电池续航，集成高质量一体灯麦设计，净重仅1130g，依旧沿续A4纸尺寸机身的极致轻量化和便携性，小小身躯也能实现专业视频创作的高效输出。</div>',
  text8: "提壶模式 2.0 + 省力腕托设计",
  text9: "省力设计，体感轻40%。",
  text10: "提壶设计 2.0",
  text11:
    'WEEBILL 3 形态重新塑造，采用全新的倒7字形态结构，<div class="mainText">提壶横梁下移至底座，大幅降低重心，进一步提高运行质感。</div>配置可伸缩第二代提壶手柄<div class="mainText">增加600%的提壶主动力臂，大幅度降低整机力臂，提高低角度和横向运镜稳定性，解决行业摆尾难题。</div>',
  text12: "省力腕托",
  text13:
    '符合人体工学交互，配置<div class="mainText">省力腕托，将云台拍摄中的物理重量合理分摊至核心手臂</div>；合理按键和握持布局，解放创作双手，让单手也能完成专业相机云台的拍摄操控，运镜轻便自如。',
  text14: "体感疲劳度降低",
  text15: "十代核心算法。",
  text16:
    '第十代蜂巢稳控算法，<div class="mainText">精细剔除运镜中的细微频率抖动，算力较上一代提升30%，创作效率更高、更省电，根据摄影师常用场景和运镜习惯重新调教跟随曲线和平滑曲线，进一步提升视频拍摄稳控性能和顺滑程度</div>；同时，配合轴臂空间和搭载相机，WEEBILL 3带来极佳舒适的拍摄感受。',
  text17: "内嵌补光灯 + 集成麦克风",
  text18: "一体方案，灯麦俱全。",
  text19:
    "从基础人物补光到拓展高清麦克风的研究探索，智云以云台为载体的全场景拍摄解决方案，让高效率的视频内容创作也能有声有色，出类拔萃。",
  text20:
    'WEEBILL 3 整合精密结构，<div class="mainText">内嵌灯麦一体技术方案。</div>',
  text21: "高效散热补光灯",
  text22: "高降噪、高保真麦克风",
  text23:
    '机身轴臂内嵌高效散热补光灯，采用Lumen Amplifier亮度增倍技术，<div class="mainText">补光效果与拍摄运镜方向完美同步，比拟口袋灯专业补光效果。</div>',
  text24: "峰值亮度",
  text25: "1000 Lux",
  text26: "双色温",
  text27: "2600K-5400K",
  text28: "显色指数",
  text29: "90+",
  text30:
    '<div class="mainText">结构散热技术</div>有效提高散热效率，提升补光灯亮度。',
  text31:
    "一改外挂收音设备绕线繁琐和空间占用问题，WEEBILL 3 在轴臂有限框架内集成高质量麦克风，无需复杂安装连线，即插即用，兼具高降噪、高保真、浑厚人声等收音特性。",
  text32: "满电创作，持续动力。",
  text33:
    '内置3颗18650规格2600mAh电池，同时<div class="mainText">支持 5V 1A 的相机供电。</div>',
  text34: "* 以上数据来源于智云实验室测试。",
  text35: "WEEBILL 3 支持",
  text36: "PD快充",
  text37: "充满100%仅需",
  text38: "2 小时",
  text39: "静态环境下续航长达",
  text40: "21 小时",
  text41: "比比细节，渐入佳境。",
  text42: "免调平双层快拆。",
  text43:
    '<div class="mainText">全新双层快装板设计，上层仅11mm厚度，大幅降低相机重心</div>，集免调平双层快拆装系统大成，<div class="mainText">相机装拆中无需调平，具备增高垫效果同时不遮挡电池仓盖</div>，更换电池更快一步。',
  text44: "磁吸扳手。",
  text45:
    '细节之处足见贴心之举，<div class="mainText">快装板底部配备磁吸扳手</div>，方便安装相机设备。',
  text46: "0.96英寸功能屏。",
  text47:
    '<div class="mainText">OLED中英显示屏</div>，内置轨迹摄影、自动V模式进阶功能，全天候拍摄状态清晰可视。',
  text48: "称心称手，自定义操作。",
  text49: "自定义扳机键。",
  text50:
    '立足于为使用者打造专属拍摄工具，首次载入功能按键自定义属性，可根据拍摄习惯在扳机键上<div class="mainText">自定义常用操作模式。</div>',
  text51: "自定义滚轮键。",
  text52:
    '滚轮支持功能自定义设置，实现<div class="mainText">相机参数调节，跟焦器、云台航向轴、横滚轴、俯仰轴</div>皆可控。',
  text53: "多场景拍摄协作。",
  text54:
    '适配鳞甲图传发射机系列和智云云图一体接收机VC100，<div class="mainText">支持图传监看，无线控制、各项画面专业参数监看和调度；集监视器、无线图传、远程控制系统于一身，性能与便携兼具。</div>持续融入鳞甲配件生态，创作者可根据拍摄任务切换不同配件，<div class="mainText">配合鳞甲跟焦器配件可远程控制焦点或焦距。</div>',
  text55: "自定义扳机键",
  text56: "自定义滚轮键",
  text57: "*以上数据来源于智云实验室环境测试所得。",
  text58: "提壶模式2.0，体感轻40%。",
  text59:
    "智云是行业第一代提壶开创者，全新设计倒7型提壶横梁、省力腕托和伸缩提壶手柄，只为高效省力创作，提壶模式2.0全新而来。",
  text60: "*以上数据来源于智云实验室环境测试所得。",
};

function App() {
  const [textData, setTextData] = useState(json);
  const isMobile = useMediaQuery({
    query: "(max-width: 1024px)",
  });
  useEffect(() => {
    async function fetchData() {
      let response = await fetch(
        `https://www.zhiyun-tech.com/website/in18/wb3/${language}.json`
      );
      if (response.ok) {
        let json = await response.json();
        function formatText(text) {
          if (text.indexOf("{") < 0 && text.indexOf("_") < 0) {
            return text;
          } else if (text.indexOf("{") >= 0) {
            let rightBrackets = text.indexOf("{");
            let leftBrackets = text.indexOf("}") + 1;
            let oldText = text.slice(rightBrackets, leftBrackets);
            let newText = `<div class="mainText">${text.slice(
              rightBrackets + 1,
              leftBrackets - 1
            )}</div>`;

            return formatText(text.replace(oldText, newText));
          } else if (text.indexOf("_") >= 0) {
            let brackets = text.indexOf("_");
            let oldText = text.slice(brackets, brackets + 1);
            let newText = `<br />`;
            return formatText(text.replace(oldText, newText));
          }
        }

        for (let item in json) {
          json[item] = formatText(json[item]);
        }
        console.log(json);
        setTextData(json);
      } else {
        console.log("HTTP-Error: " + response.status);
      }
    }

    fetchData();
  }, []);
  return (
    <div className="App">
      <Header language={language} textData={textData} isMobile={isMobile} />
      <div
        style={{
          width: "100vw",
          height: "600vh",
        }}
      ></div>
      <Algorithm textData={textData} />
      <Light textData={textData} />
      <div
        style={{
          width: "100vw",
          height: "500vh",
        }}
      ></div>

      <ToggleFullScreenLayout
        data={{
          header: DOMPurify.sanitize(textData["text41"]),
          contents: [
            {
              mediaType: "video",
              title: DOMPurify.sanitize(textData["text42"]),
              body: DOMPurify.sanitize(textData["text43"]),
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-1-poster.jpg",
              video:
                "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-1.mp4",
              note: DOMPurify.sanitize(textData["text57"]),
            },
            {
              mediaType: "img",
              title: DOMPurify.sanitize(textData["text44"]),
              body: DOMPurify.sanitize(textData["text45"]),
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-2-poster.jpg",
              video:
                "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-2.mp4",
            },
            {
              mediaType: "video",
              title: DOMPurify.sanitize(textData["text46"]),
              body: DOMPurify.sanitize(textData["text47"]),
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-3.jpg",
            },
          ],
        }}
      />

      <Custom textData={textData} />
      <Cooperation textData={textData} />
      <Battery textData={textData} />
      {/* <FullpagePinLayout>
        <div>
          <h1>精密结构工艺。</h1>
          <h5>
            <span className="mainText">
              WEEBILL 3
              立体流畅机身以精密设计，精湛工艺和机械工程技术将390余个零部件集成一体，
            </span>
            机臂和内部结构加强处理，给足创作安全感，轻松驾驭复杂拍摄环境。
          </h5>
        </div>

        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          src="https://bucket.zhiyun-tech.com/detail/m2s/M2S.mp4"
        ></video>
      </FullpagePinLayout>

      <FullpagePinLayout>
        <div>
          <h1>A4级轻量机身。</h1>
          <h5>
            精准裁切每寸空间，沿续
            <span className="mainText">
              A4纸尺寸机身的极致轻量化和便携性，净重仅1130g，整机较同类产品轻约30%
            </span>
            ，小小身躯也能实现专业视频创作的高效输出。
          </h5>
        </div>

        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          src="https://bucket.zhiyun-tech.com/detail/m2s/M2S.mp4"
        ></video>
      </FullpagePinLayout>

      <FullpagePinLayout>
        <div>
          <h1>十代核心算法。</h1>
          <h5>
            第十代蜂巢稳控算法，
            <span className="mainText">
              精细剔除运镜中的细微频率抖动，根据摄影师常用场景和运镜习惯重新调教跟随曲线和平滑曲线
            </span>
            ，进一步提升视频拍摄稳控性能和顺滑程度；同时，配合轴臂空间和搭载相机，WEEBILL
            3带来极佳舒适的拍摄感受。
          </h5>
        </div>

        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          src="https://bucket.zhiyun-tech.com/detail/m2s/M2S.mp4"
        ></video>
      </FullpagePinLayout>
      <Light />
      <Battery />
      <ToggleFullScreenLayout
        data={{
          header: "比比细节，<br />渐入佳境。",
          contents: [
            {
              title: "0.96英寸功能屏",
              body: "OLED中英显示屏，内置延时摄影、自动V模式进阶功能，全天候拍摄状态清晰可视。",
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-1.jpg",
            },
            {
              title: "免调平双层快拆",
              body: "集免调平双层快拆装系统大成，相机装拆中无需调平，具备增高垫效果同时不遮挡电池仓盖，更换电池更快一步。",
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-2.jpg",
            },
            {
              title: "磁吸扳手",
              body: "细节之处足见贴心之举，快装板底部配备磁吸扳手，方便安装相机设备。",
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-3.jpg",
            },
          ],
        }}
      />

      <ToggleFullScreenLayout
        direction="reverse"
        data={{
          header: "称心称手，<br />自定义操作。",
          contents: [
            {
              title: "自定义扳机键。",
              body: "立足于为使用者打造专属拍摄工具，首次载入功能按键自定义属性，可根据拍摄习惯在扳机键上自定义常用操作模式。",
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-1.jpg",
            },
            {
              title: "自定义滚轮键。",
              body: "滚轮支持功能自定义设置，实现相机参数调节，跟焦器、云台航向轴、横滚轴、俯仰轴皆可控。",
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-2.jpg",
            },
          ],
        }}
      />

      <ToggleFullScreenLayout
        data={{
          header: "多场景拍摄协作。",
          contents: [
            {
              title: "鳞甲图传发射机。",
              body: "适配鳞甲图传发射机系列和智云云图一体接收机VC100，支持图传监看，无线控制、各项画面专业参数监看和调度。",
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-1.jpg",
            },
            {
              title: "鳞甲跟焦器。",
              body: "持续融入鳞甲配件生态，创作者可根据拍摄任务切换不同配件，配合鳞甲跟焦器配件可远程控制焦点或焦距。",
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-2.jpg",
            },
            {
              title: "智云云图一体接收机。",
              body: "接收机集监视器、无线图传、远程控制系统于一身，性能与便携兼具。人体工学手柄设计，亲肤硅胶贴合握持。无需复杂安装和连线，开机即可自动对频。",
              img: "https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-8-3.jpg",
              videoSrc: "https://bucket.zhiyun-tech.com/detail/m2s/M2S.mp4",
            },
          ],
        }}
      />

      <div className="swiper-ctn">
        <Swiper
          modules={[Navigation, Pagination, A11y]}
          grabCursor={true}
          pagination={{ clickable: true }}
          // spaceBetween={48}
          navigation={{
            nextEl: ".swiper-next",
            prevEl: ".swiper-pre",
          }}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper) => console.log(swiper)}
          breakpoints={{
            // when window width is >= 320px
            0: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            // when window width is >= 480px
            414: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            // when window width is >= 640px
            1024: {
              slidesPerView: 2,
              spaceBetween: 48,
            },
          }}
          className="swiper-box"
        >
          <SwiperSlide>Slide 1</SwiperSlide>
          <SwiperSlide>Slide 2</SwiperSlide>
          <SwiperSlide>Slide 3</SwiperSlide>
          <SwiperSlide>Slide 4</SwiperSlide>
          <div className="swiper-next">
            <svg
              width="96"
              height="96"
              viewBox="0 0 96 96"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_b_3064_58862)">
                <path
                  d="M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z"
                  fill="black"
                  fill-opacity="0.2"
                />
                <path
                  d="M51.4054 36L64.0002 48M64.0002 48L51.4054 60M64.0002 48H32"
                  stroke="white"
                  stroke-width="2"
                />
              </g>
              <defs>
                <filter
                  id="filter0_b_3064_58862"
                  x="-40"
                  y="-40"
                  width="176"
                  height="176"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImage" stdDeviation="20" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_3064_58862"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_3064_58862"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="swiper-pre">
            <svg
              width="96"
              height="96"
              viewBox="0 0 96 96"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_b_3064_61096)">
                <path
                  d="M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z"
                  fill="black"
                  fill-opacity="0.2"
                />
                <path
                  d="M44.5946 60L31.9998 48M31.9998 48L44.5946 36M31.9998 48L64 48"
                  stroke="white"
                  stroke-width="2"
                />
              </g>
              <defs>
                <filter
                  id="filter0_b_3064_61096"
                  x="-40"
                  y="-40"
                  width="176"
                  height="176"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImage" stdDeviation="20" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_3064_61096"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_3064_61096"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        </Swiper>
      </div> */}
    </div>
  );
}

export default App;
